import { createContext } from "react";
const UpdatesOrderContext = createContext();
export default UpdatesOrderContext;

